// Effect 2 — Sound. The cheapest juice per minute of work, full stop. Three synth blips: a bright
// tick on a valid word, a low buzz on a reject, and a flat, contemptuous thud on a flagged word
// (the profanity punchline — heard, dismissed).
import { feel } from "../feel";
import { blip } from "../audio";
import { registerEffect, effectEnabled } from "../registry";
import { bus } from "../../core/bus";
import { intensity } from "../../tuner/scale";

export function registerSound(): void {
  registerEffect({ name: "sound", label: "2 · Sound" }, "word:valid", () => {
    blip({
      freq: feel.sound.validFreq,
      type: feel.sound.waveform as OscillatorType,
      volume: feel.sound.volume * intensity(feel.sound), // intensity scales the valid-word blip
      durationMs: 80,
    });
  });

  // The other two moments share the same kill switch ("sound"), gated manually.
  bus.on("word:invalid", () => {
    if (!effectEnabled("sound")) return;
    blip({ freq: feel.sound.invalidFreq, type: "sawtooth", volume: feel.sound.volume, durationMs: 140 });
  });
  bus.on("word:flagged", () => {
    if (!effectEnabled("sound")) return;
    // Deliberately dull and short — the flattest possible contempt.
    blip({ freq: feel.sound.flaggedFreq, type: "sine", volume: feel.sound.volume * 0.8, durationMs: 110 });
  });
}
